import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { NavLink, useSearchParams } from "react-router-dom";
import PageHeading from "@/v2/components/ui/heading/Page";
import { DataTable, TableToolbar } from "@/v2/components/data-table/table";
import { Payslip } from "@/v2/types";
import AccessControl from "@/v2/components/rbac/AccessControl";
import FindAllPayslip from "@/v2/api/payslip/FindAll";
import parseUrlToQueryParams from "@/v2/utils/parseUrlToQueryParams";

import {
    ArEmployeePayslipColumn,
    ArEmployeePayslipFilterColumn,
} from "@/v2/components/data-table/columns/ArEmployeePayslipColumn";
import { UTCDate } from "@date-fns/utc";
import { useState } from "react";
import { format } from "date-fns";
import MonthYearPicker from "@/v2/components/ui/MonthPicker";

export default function ArEmployeePayslipPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const now = new UTCDate();
    const currentMonth = format(now, "yyyy-MM");
    const appliedMonth = searchParams.get("month");

    const [month, setMonth] = useState(appliedMonth || currentMonth);

    const monthNumber = Number(month.split("-")[1]);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["payslip", skip, limit, search, filter, month],
        queryFn: () =>
            FindAllPayslip({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter: {
                    ...filter,
                    type: { eq: ["MONTHLY_OT"] },
                    month: { eq: monthNumber },
                },
            }),
    });

    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="AR Employee Payslip Database"
                    description="Manage and monitor all ar employee payslip in your platform"
                />

                <div className="flex items-center justify-center gap-2">
                    <MonthYearPicker month={month} setMonth={setMonth} />

                    <AccessControl
                        module="PAYSLIP_MANAGEMENT"
                        requestedAccess={"POST"}
                    >
                        <div className="flex gap-4">
                            <NavLink to={"create"}>
                                <Button>Add New AR Employee Payslip</Button>
                            </NavLink>
                        </div>
                    </AccessControl>
                </div>
            </div>

            <Card className="p-2">
                <TableToolbar<Payslip>
                    column={ArEmployeePayslipFilterColumn}
                    searchPlaceHolder="Search payslip.."
                />

                <DataTable<Payslip>
                    data={query.data?.data?.payslips || []}
                    columns={ArEmployeePayslipColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
